<div class="agent-state bg {{ agent?.agent_status_detail }}">
  {{ ('agent_status.' + agent?.agent_status_detail) |translate }}
</div>
